import { ca } from '@cian/analytics';

export function trackServiceBannerClickChange(newbuildingId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'click_sopr',
    label: 'sellers_type_guide',
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
  });
}
